<script type="text/javascript">
	import Hotkeys from "./Hotkeys";
	import ModalWindow from "../UI/ModalWindow.svelte";

	export let open = false;
	let data = Hotkeys.data;
</script>

<style type="text/scss">
	ul.hotkeys-modal-list li {
		padding: 5px;

		code {
			font-family: "SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono","Menlo","Courier",monospace;
			color: #eb5a46;
			border-radius: 3px;
			box-shadow: 0 0 0 1px rgba(9,30,66,.13);
			padding: 1px 3px;
			margin: -1px 2px;
		}
	}
</style>

<ModalWindow title={`Hotkeys`} hasCloseButton={false} bind:open={open}>
	<ul class='hotkeys-modal-list'>
		{#each $data as hotkey}
			<li><code>{hotkey.data.code}</code> - {hotkey.data.name}</li>
		{/each}
	</ul>
</ModalWindow>
